<div class="logout-header-wrapper">
  <div class="user-info hidden-xs">
    <ion-icon color="primary" name="person-outline"></ion-icon>
    <strong>{{name}}</strong>
  </div>
  <div class="user-info hidden-xs">
    <ion-icon color="primary" name="business-outline" class="ion-margin-start"></ion-icon>
    <span class="company">{{company}}</span>
  </div>
  <!-- Legg trucks og logout-btn i en egen flex-container -->
  <div class="header-actions">
    <div class="trucks">
      <ion-button fill="clear" (click)="showTrucksTrailersModal()">
        <img src="assets/icon/Icon_Truck.svg" class="truck-icon" title="Velg lastebil"/>
        <span class="black">{{currentTruckTrailer?.Truck?.Description}} <span class="hidden-xs">/ {{currentTruckTrailer?.Trailer?.Description}}</span></span>
      </ion-button>
    </div>
    <div class="logout-btn">
      <ion-button (click)="logout()" fill="clear">
        <ion-icon slot="icon-only" size="large" name="power-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>



  <!--div class="alerts">
    <ion-button
      *ngIf="userService.localStorageData.length > 10000000"
      (click)="processQueue()"
      fill="clear"
    >
      <ion-icon name="sync-outline" slot="icon-only" color="primary"></ion-icon>
      <span class="hidden-xs">{{ 'Sync.sync' | translate }}</span>
    </ion-button>
    <<span
      class="blinkWrapper blink"
      *ngIf="showReleaseAlert"
      (click)="navigateToRelease()"
    >
      <ion-icon name="megaphone-outline" color="primary"></ion-icon>
      <span class="hidden-xs"></span>
    </span>
  </div-->
